import { TypeInitProps, TypeRequest } from '../../types';
import { encryptParams } from '../../utils/index';
import { APP_URL } from '../../utils/urls';

export default class BindAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  unbindUnusableMobile = (params: {
    mobile: string;
    code: string;
    extra_params?: object;
  }) => {
    const { mobile, code, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, scene: 1, ...extra_params }, [
      'mobile',
      'code',
    ]);
    return this.request({
      url: APP_URL.UNBIND_UNUSABLE_MOBILE,
      method: 'POST',
      data,
    });
  };
}
